import dayjs from 'dayjs';

export function formatTimestamp(timestamp) {
    return dayjs(timestamp).format('DD MMM YYYY [at] h:mm A');
  }